import { KSK2021_R01DetailDto } from './Dto_KSK2021_R01';

export const getDetailGroupKey = (item: Pick<KSK2021_R01DetailDto, 'warehouseCd' | 'childItemcd'>) =>
	`${item.warehouseCd ?? ''}::${item.childItemcd ?? ''}`;

/**
 * getKSK2021_R01DetailList LOT 단위 응답을
 * 출고창고(warehouseCd) + 자재코드(childItemcd) 기준으로 취합한다.
 */
export const aggregateKSK2021_R01DetailList = (
	detailList: KSK2021_R01DetailDto[],
): KSK2021_R01DetailDto[] => {
	const groupMap = new Map<string, KSK2021_R01DetailDto[]>();

	detailList.forEach((item) => {
		const key = getDetailGroupKey(item);
		const group = groupMap.get(key) ?? [];
		group.push(item);
		groupMap.set(key, group);
	});

	return Array.from(groupMap.values()).map((group, idx) => {
		const first = group[0];
		const totalLotQty = group.reduce((sum, item) => sum + (Number(item.lotQty) || 0), 0);

		return {
			...first,
			valueIndex: idx + 1,
			orderIndex: idx + 1,
			orderIndexSeq: 0,
			lotQty: totalLotQty,
			lotNo: '',
			feederNo: '',
			transportQty: 0,
			transportedQty: 0,
			inserted: false,
			isModified: false,
		};
	});
};

export const findAggregatedDetailItem = (
	list: KSK2021_R01DetailDto[],
	target: Pick<KSK2021_R01DetailDto, 'warehouseCd' | 'childItemcd'>,
) => list.find((item) => getDetailGroupKey(item) === getDetailGroupKey(target));

export const normalizeKSK2021_R01DetailList = (
	detailList: KSK2021_R01DetailDto[],
): KSK2021_R01DetailDto[] =>
	detailList.map((value, idx) => ({
		...value,
		valueIndex: value.valueIndex ?? idx + 1,
		orderIndex: value.orderIndex ?? idx + 1,
		orderIndexSeq: value.orderIndexSeq ?? 0,
		lotQty: value.lotQty ?? 0,
		coordinateUsage: value.coordinateUsage ?? value.childItemUsage ?? 0,
		transportQty: 0,
		transportedQty: 0,
	}));
